
function Offer() {
  return (
    <>
      <div className="content-wrapper">
        <div
          className="content-heading d-flex
                          justify-content-between"
        >
          <div>Plans & Offer</div>
          <div> 
          </div>
        </div>
      </div>
    </>
  );
}

export default Offer;
